var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDashLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8061 15.8487C11.8061 15.8487 11.2829 15.4439 10.78 15.0538C11.4602 15.0538 14.2147 15.0517 16.276 15.0505C16.5347 14.9721 16.1144 14.6472 16.276 14.6472L16.1446 14.3812H8.82227L11.4043 16.3828L11.8061 15.8487Z",
    fill: "#c82d33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.8061 15.8487C11.8061 15.8487 11.2829 15.4439 10.78 15.0538C11.4602 15.0538 14.2147 15.0517 16.276 15.0505C16.5347 14.9721 16.1144 14.6472 16.276 14.6472L16.1446 14.3812H8.82227L11.4043 16.3828L11.8061 15.8487Z",
    fill: "#c82d33"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.1586 18.937C17.1586 18.937 17.3753 19.6493 17.5808 20.3274C17.2059 20.0369 14.7833 18.1711 13.0673 16.8491C12.808 16.8143 13.0017 17.2095 12.8192 17.0682C12.7363 17.25 12.8225 17.4815 12.8225 17.4815L18.825 22.1387L17.7908 18.7388L17.1586 18.937Z",
    fill: "#c82d33"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.8808 15.0538H19.2206C18.6448 15.5001 16.3509 17.2797 14.7057 18.5551C14.5937 18.7965 15.0395 18.661 14.9278 18.7472C14.9045 18.9778 15.2022 19.0156 15.2022 19.0156L21.1778 14.3812H17.8808V15.0538Z",
    fill: "#c82d33"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.6034 13.1551C14.6034 13.1551 14.9308 12.0794 14.9995 11.8515C15.2192 12.5708 16.074 15.37 16.7188 17.4806C16.9766 17.6624 16.8616 16.7072 16.993 17.1381C17.3122 17.276 17.2756 17.0476 17.2756 17.0476L14.9995 9.57604L13.9707 12.9557L14.6034 13.1551Z",
    fill: "#c82d33"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5151 19.4768C13.5151 19.4768 12.9574 19.9107 12.4203 20.3268C12.6276 19.6474 13.4885 16.8158 14.1094 14.7736C14.2213 14.3542 13.6936 15.0202 13.765 14.7866C13.6728 14.3542 13.4567 14.6481 13.4567 14.6481L11.1758 22.1387L13.9172 20.0115L13.5151 19.4768Z",
    fill: "#c82d33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4157 13.4082H24.0124C23.118 14.1018 18.459 17.7201 15.9663 19.6555C15.8976 19.8697 16.3421 19.8253 16.1787 19.9514C16.1527 20.1593 16.4961 20.0846 16.4961 20.0846L25.9708 12.7356H17.4157V13.4082Z",
    fill: "#c82d33"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.9001 20.4737C14.9001 20.4737 11.0681 23.4461 9.37541 24.7593C9.8414 23.2309 11.456 17.9223 11.456 17.9223C11.456 17.9223 11.9568 16.2435 12.3995 14.7536C12.3193 14.4585 11.9834 15.018 12.0751 14.7058C11.9765 14.5263 11.7529 14.5859 11.7529 14.5859L10.8233 17.7262L8.13086 26.5703L15.2992 21.0099L14.9001 20.4737Z",
    fill: "#c82d33"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.8722 13.1554L14.544 7.78474C14.544 7.78474 14.7809 7.00467 15.003 6.27663C15.3537 7.42678 17.0788 13.094 18.065 16.3353C18.3046 16.6573 18.3197 15.8497 18.3815 16.0539C18.5603 16.1392 18.6623 16.0203 18.6623 16.0203L15.003 3.99995L13.9128 7.58261L12.2383 12.9557L12.8722 13.1554Z",
    fill: "#c82d33"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5107 17.8085C18.5107 17.8085 19.9847 22.65 20.6255 24.7599C19.7256 24.0597 15.1941 20.5503 12.6269 18.5611C12.3691 18.476 12.5458 18.9033 12.3809 18.7747C12.1963 18.8155 12.285 19.1342 12.285 19.1342L21.8701 26.5703L19.1432 17.6088L18.5107 17.8085Z",
    fill: "#c82d33"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.03125 12.7346L10.8622 18.0332C10.8622 18.0332 11.3582 17.4804 11.5119 17.3094C11.4901 17.3251 11.265 17.4991 11.265 17.4991C11.265 17.4991 7.17001 14.3238 5.98901 13.4072H15.5215C15.6558 13.258 15.6159 12.7346 15.6159 12.7346H4.03125Z",
    fill: "#c82d33"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashLogo);
export default __webpack_public_path__ + "static/media/dashLogo.234300eaa0f8af11f7d6e3e4df349a7a.svg";
export { ForwardRef as ReactComponent };